namespace Serenity.Extensions {
    export interface UserPreferenceRetrieveResponse extends ServiceResponse {
        Value?: string;
    }
}
